var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('div',{},[_c('AccountSubheader'),_c('p',[_vm._v("Account Manager")]),_c('AccountManagerComponent')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }